import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useAppSelector } from '../../reducers';
import { billingNameKeySelector } from '../../selectors/ProductsSelectors';
import { Inbound25CopyChange } from '../common/i18n/CopyChangeComponents';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO gross prop
const BillingNameTitle = ({
  skuId,
  bilingNameKey
}) => {
  const billingNameKey = useAppSelector(state => {
    if (bilingNameKey !== undefined) return bilingNameKey;
    return billingNameKeySelector(state, {
      skuId
    });
  });
  if (!isValidI18nKey(`pricing-pages-ui.productNamesV2.${billingNameKey}.title`)) return null;
  return /*#__PURE__*/_jsx(Inbound25CopyChange, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages-ui.productNamesV2.${billingNameKey}.title`
    })
  });
};
export default BillingNameTitle;